'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var debug = require('debug');

var parseDuration = require('parse-duration');

var crypto = require('libp2p-crypto');

var errcode = require('err-code');

var log = debug('ipfs:name:publish');
log.error = debug('ipfs:name:publish:error');

var _require = require('../../utils'),
    OFFLINE_ERROR = _require.OFFLINE_ERROR,
    normalizePath = _require.normalizePath,
    withTimeoutOption = _require.withTimeoutOption;

var _require2 = require('./utils'),
    resolvePath = _require2.resolvePath;
/**
 * @typedef { import("../index") } IPFS
 */

/**
 * IPNS - Inter-Planetary Naming System
 *
 * @param {IPFS} self
 * @returns {Object}
 */


module.exports = function (_ref) {
  var ipns = _ref.ipns,
      dag = _ref.dag,
      peerInfo = _ref.peerInfo,
      isOnline = _ref.isOnline,
      keychain = _ref.keychain,
      constructorOptions = _ref.options;

  var lookupKey = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(keyName) {
      var pass, pem, privateKey;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(keyName === 'self')) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", peerInfo.id.privKey);

            case 2:
              _context.prev = 2;
              pass = constructorOptions.pass;
              _context.next = 6;
              return keychain.exportKey(keyName, pass);

            case 6:
              pem = _context.sent;
              _context.next = 9;
              return crypto.keys.import(pem, pass);

            case 9:
              privateKey = _context.sent;
              return _context.abrupt("return", privateKey);

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](2);
              log.error(_context.t0);
              throw errcode(_context.t0, 'ERR_CANNOT_GET_KEY');

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 13]]);
    }));

    return function lookupKey(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  /**
   * IPNS is a PKI namespace, where names are the hashes of public keys, and
   * the private key enables publishing new (signed) values. In both publish
   * and resolve, the default name used is the node's own PeerID,
   * which is the hash of its public key.
   *
   * @param {String} value ipfs path of the object to be published.
   * @param {Object} options ipfs publish options.
   * @param {boolean} options.resolve resolve given path before publishing.
   * @param {String} options.lifetime time duration that the record will be valid for.
  This accepts durations such as "300s", "1.5h" or "2h45m". Valid time units are
  "ns", "ms", "s", "m", "h". Default is 24h.
    * @param {String} options.ttl time duration this record should be cached for (NOT IMPLEMENTED YET).
    * This accepts durations such as "300s", "1.5h" or "2h45m". Valid time units are
    "ns", "ms", "s", "m", "h" (caution: experimental).
    * @param {String} options.key name of the key to be used, as listed by 'ipfs key list -l'.
    * @param {function(Error)} [callback]
    * @returns {Promise|void}
    */


  return withTimeoutOption( /*#__PURE__*/function () {
    var _publish = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(value, options) {
      var resolve, lifetime, key, pubLifetime, results;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              options = options || {};
              resolve = !(options.resolve === false);
              lifetime = options.lifetime || '24h';
              key = options.key || 'self';

              if (isOnline()) {
                _context2.next = 6;
                break;
              }

              throw errcode(new Error(OFFLINE_ERROR), 'OFFLINE_ERROR');

            case 6:
              _context2.prev = 6;
              value = normalizePath(value);
              _context2.next = 14;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](6);
              log.error(_context2.t0);
              throw _context2.t0;

            case 14:
              _context2.prev = 14;
              pubLifetime = parseDuration(lifetime); // Calculate lifetime with nanoseconds precision

              pubLifetime = pubLifetime.toFixed(6);
              _context2.next = 23;
              break;

            case 19:
              _context2.prev = 19;
              _context2.t1 = _context2["catch"](14);
              log.error(_context2.t1);
              throw _context2.t1;

            case 23:
              _context2.next = 25;
              return Promise.all([// verify if the path exists, if not, an error will stop the execution
              lookupKey(key), resolve ? resolvePath({
                ipns: ipns,
                dag: dag
              }, value) : Promise.resolve()]);

            case 25:
              results = _context2.sent;
              return _context2.abrupt("return", ipns.publish(results[0], value, pubLifetime));

            case 27:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[6, 10], [14, 19]]);
    }));

    function publish(_x2, _x3) {
      return _publish.apply(this, arguments);
    }

    return publish;
  }());
};